import type { WidgetItem, CalendarViewType } from "@/types/dashboard"

import ActivityDistributionWidget from "./widgets/ActivityDistributionWidget"
import SessionDistributionWidget from "./widgets/SessionDistributionWidget"
import TeamSummaryWidget from "./widgets/TeamSummaryWidget"
import NoticeWidget from "./widgets/NoticeWidget"
import ActivityCalendarWidget from "./widgets/ActivityCalendarWidget"
import QuickReportWidget from "./widgets/QuickReportWidget"
import RecentReportWidget from "./widgets/RecentReportWidget"

interface WidgetRendererProps {
  widget: WidgetItem
}

export default function WidgetRenderer({ widget }: WidgetRendererProps) {
  switch (widget.widgetType) {
    case "team-summary":
      return <TeamSummaryWidget />
    case "activity-distribution":
      return <ActivityDistributionWidget />
    case "session-distribution":
      return <SessionDistributionWidget />
    case "notice":
      return <NoticeWidget />
    case "calendar":
      return (
        <ActivityCalendarWidget
          view={(widget.options.defaultView as CalendarViewType) ?? "monthly"}
        />
      )
    case "quick-report":
      return <QuickReportWidget />
    case "recent-report":
      return <RecentReportWidget />
    default:
      return <div>Unknown widget type</div>
  }
}
